import styled from "styled-components";

export const IGCIndicatorProgressPieDefaultBox = styled.div`
    position: relative;
    padding: 3px;
    width: 100%;
    height: 100%;
    transition: width 0.4s ease-in, height 0.4s ease-in, margin 0.4s ease-in;

    &::after{
        content: "8";
        position: absolute;
        top: 50%;
        left: 50%;
        
        color: ${({theme}) => theme.colors.textContrast};
        font-size: 1.4rem;
        transform: translate(-50%, -50%);

    }
    
    svg {
        background: transparent;
        border-radius: 50%;
        display: block;
        overflow: visible;
    }

    circle#outline {
        stroke: ${({theme}) => theme.colors.boxBorderContrast};
    }

    circle#progress {
        transform-origin: center;
        transform: rotate(-90deg);
        fill: transparent;
        stroke: #FFCA4F;
        transition: stroke-dasharray 0.2s ease-in, stroke 0.2s ease-in;
    }
`;
